var _path, _path2, _rect, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1878 5.53476C12.8438 5.53476 12.3881 5.52714 11.8208 5.52714C10.4372 5.52714 9.29954 4.382 9.29954 2.98543V0.535139C9.29954 0.342377 9.14572 0.185425 8.95478 0.185425H4.92479C3.04406 0.185425 1.52393 1.72904 1.52393 3.62085V11.8304C1.52393 13.8151 3.11647 15.4235 5.0817 15.4235H11.083C12.9569 15.4235 14.4763 13.8898 14.4763 11.9965V5.87762C14.4763 5.68409 14.3232 5.5279 14.1315 5.52866C13.8094 5.53095 13.4231 5.53476 13.1878 5.53476Z",
    fill: "#8987E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1119 0.617712C10.8841 0.38076 10.4864 0.543808 10.4864 0.872189V2.88133C10.4864 3.724 11.1805 4.41733 12.0231 4.41733C12.5542 4.42343 13.2917 4.42495 13.918 4.42343C14.2387 4.42266 14.4018 4.03943 14.1793 3.80781C13.3755 2.972 11.9363 1.47409 11.1119 0.617712Z",
    fill: "#8987E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 6.54285,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    fill: "#8987E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 6.54285,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57144 12.043C5.39987 12.043 6.07144 11.3714 6.07144 10.543C6.07144 9.71456 5.39987 9.04298 4.57144 9.04298C3.74301 9.04298 3.07144 9.71456 3.07144 10.543C3.07144 11.3714 3.74301 12.043 4.57144 12.043Z",
    stroke: "#DFDFFF",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29776 13.6766C2.52828 13.2775 2.85975 12.9462 3.25886 12.7159C3.65797 12.4855 4.11067 12.3643 4.57148 12.3643C5.0323 12.3643 5.48499 12.4855 5.8841 12.7159C6.2832 12.9463 6.61466 13.2776 6.84518 13.6766",
    stroke: "#DFDFFF",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignExpert);
export default __webpack_public_path__ + "static/media/assignExpert.6a35593555ddc5ce371e7f9efbad7bd6.svg";
export { ForwardRef as ReactComponent };